import createPageConstants from '../shared/util/createPageConstants';
export const RegistrationConstants = createPageConstants('registrations', 'Registration', {
  defaultDefault: 'registrationsList',
  editor: 'registrationEditor',
});
